export function isTestEnvironment(urlString: string): boolean {
	let url = new URL(urlString);

	if (url.host.startsWith('localhost') || url.host.startsWith('test.')) {
		return true;
	}

	return false;
}